import { BiMapMarker } from "./BiMapMarker";

export class BiMapTools {
  public static getMarkersInsideShape(shape: L.Layer, currentMapMarkers: Array<BiMapMarker>) {
    if (shape instanceof L.Polygon) return currentMapMarkers.filter(m => BiMapTools.isMarkerInsidePolygon(m, shape));
    else if (shape instanceof L.Circle) return currentMapMarkers.filter(m => this.isMarkerInsideCircle(m, shape as L.Circle));
    else if (shape instanceof L.Polyline) return currentMapMarkers.filter(m => shape.getBounds().contains(m.getLatLng()));
    else return [shape as BiMapMarker]; // assume it's a Marker
  }

  /**
   * Determines if a marker is within the bounds of a polygon. Credits goes to: https://stackoverflow.com/a/31813714
   */
  public static isMarkerInsidePolygon(marker: BiMapMarker, poly: L.Polygon) {
    const polyPoints = poly.getLatLngs()[0] as L.LatLng[];
    const x = marker.getLatLng().lat,
      y = marker.getLatLng().lng;

    let inside = false;
    for (let i = 0, j = polyPoints.length - 1; i < polyPoints.length; j = i++) {
      const xi = polyPoints[i].lat,
        yi = polyPoints[i].lng;
      const xj = polyPoints[j].lat,
        yj = polyPoints[j].lng;

      const intersect = yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
      if (intersect) inside = !inside;
    }
    return inside;
  }

  public static isMarkerInsideCircle(marker: BiMapMarker, circle: L.Circle) {
    return circle.getLatLng().distanceTo(marker.getLatLng()) <= circle.getRadius();
  }
}
